var n=function(n,r,i){var t;if(!r||!i)return n;var e=i.find((function(n){var r=n.breakpoint;return r==r}));if(!e)return n;var u=e.settings;return u&&"unslick"!==u&&null!==(t=u.infinite)&&void 0!==t?t:n};export{n as default};
